module.exports = __webpack_public_path__ + "static/main-logo-f356a69274aec9ab9fbf634a93dab547.svg";